import { useState, useEffect, useCallback } from "react";
import { Search } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";
import api, { fileUrl } from "../lib/api";

export default function GifPicker({ onPick, trigger }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [gifs, setGifs] = useState([]);

  const load = useCallback(async (query) => {
    try { const { data } = await api.get(`/gifs?q=${encodeURIComponent(query)}`); setGifs(data); } catch {}
  }, []);

  useEffect(() => { if (open) load(""); }, [open, load]);
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => load(q), 250);
    return () => clearTimeout(t);
  }, [q, open, load]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {trigger || (
          <button type="button" data-testid="gif-picker-btn" className="px-2 py-1 rounded-full hover:bg-secondary text-sage font-bold text-xs border border-sage/40">
            GIF
          </button>
        )}
      </PopoverTrigger>
      <PopoverContent className="w-72 rounded-2xl p-3" data-testid="gif-picker-panel">
        <div className="relative mb-2">
          <Search className="w-4 h-4 absolute left-2.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input data-testid="gif-search" value={q} onChange={(e) => setQ(e.target.value)}
            placeholder="Search moods: happy, hug…" className="pl-8 h-9 rounded-full text-sm" />
        </div>
        <div className="grid grid-cols-3 gap-2 max-h-64 overflow-y-auto no-scrollbar">
          {gifs.length === 0 ? (
            <p className="col-span-3 text-xs text-muted-foreground text-center py-4">No GIFs found.</p>
          ) : gifs.map((g) => (
            <button key={g.id} type="button" data-testid={`gif-${g.slug}`}
              onClick={() => { onPick(g.url); setOpen(false); }}
              className="rounded-lg overflow-hidden hover:ring-2 ring-copper transition-all">
              <img src={fileUrl(g.url)} alt={g.title} className="w-full h-16 object-cover bg-secondary" />
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
